import { CaseDraftDataWire } from 'app/area/shared/case-draft-info-panel/types';
import { RemoteData } from 'app/infrastructure/remote-data';

const endpoint = {
  userDrafts: 'case/draft/user/current'
};

export const api = {
   getDraftsData: async (): Promise<CaseDraftDataWire[]> => {
    const response: any = await new RemoteData(endpoint.userDrafts).resource<any[]>().all();
    return response.data;
  }
};
